import { render, staticRenderFns } from "./shopsetting.vue?vue&type=template&id=025ae57a"
import script from "./shopsetting.vue?vue&type=script&lang=js"
export * from "./shopsetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports